import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  fragment FragmentAgentChatMessageInfo on AgentChatMessageInfo {
    type
    createdAt
    payload
  }
`

export const TRANSFORMER = graphql.transformers.OUT.custom<
  graphql.schema.FragmentAgentChatMessageInfoFragment,
  ents.core.agent.Info
>(infoItem => {
  const { type, createdAt, payload } = infoItem
  let parsedPayload: Record<string, unknown>
  if (typeof payload === 'string' && payload.length > 0) {
    const once = JSON.parse(payload) as unknown
    parsedPayload =
      typeof once === 'string'
        ? (JSON.parse(once) as Record<string, unknown>)
        : (once as Record<string, unknown>)
  } else if (payload && typeof payload === 'object') {
    parsedPayload = payload as Record<string, unknown>
  } else {
    parsedPayload = {}
  }
  return {
    ...parsedPayload,
    type,
    createdAt: typeof createdAt === 'string' ? new Date(createdAt) : new Date(),
  } as ents.core.agent.Info
})
